import script from "./ManageDepartments.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageDepartments.vue?vue&type=script&setup=true&lang=js"

import "./ManageDepartments.vue?vue&type=style&index=0&id=3ac59d5a&lang=scss"

const __exports__ = script;

export default __exports__